import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Config from '../../Config.js';
import swal from 'sweetalert';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function Passwordmanagement() {
    let history = useHistory();
    const [show, setshow] = useState(false);
    const [SubloginId, setSubloginId] = useState("");
    const [UserID, setUserID] = useState("");
    const [CurrentUserLoginRole, setCurrentUserLoginRole] = useState("");
    const [UserProfileOldPassword, setUserProfileOldPassword] = useState("");
    const [UserProfileOldPasswordError, setUserProfileOldPasswordError] = useState("");
    const [UserProfileNewPassword, setUserProfileNewPassword] = useState("");
    const [UserProfileNewPasswordError, setUserProfileNewPasswordError] = useState("");
    const [UserProfileConfirmPassword, setUserProfileConfirmPassword] = useState("");
    const [UserProfileConfirmPasswordError, setUserProfileConfirmPasswordError] = useState("");
    const [CurrentUserLoginName, setCurrentUserLoginName] = useState(localStorage.getItem('loginName'));
    const [CurrentUserLoginEmail, setCurrentUserLoginEmail] = useState(localStorage.getItem('loginEmail'));
    const [Auth0ID, setAuth0ID] = useState(localStorage.getItem('auth0id'));
    const [CurrentUserLoginPassword, setCurrentUserLoginPassword] = useState("");

    useEffect(() => {
        let checkLogin = localStorage.getItem("loginUserID");
        if (checkLogin === '' || checkLogin === "" || checkLogin === undefined || checkLogin === null) {
            return () => {
                history.push('/Login');
            };
        }
        else {
            // BindIndivualId(checkLogin);
          

        }
    }, []);

    const onChangeSubLoginOldPassword = (event) => {
        setUserProfileOldPasswordError('');
        setUserProfileOldPassword(event.target.value);
    }

    const onChangeSubLoginNewPassword = (event) => {
        setUserProfileNewPasswordError('');
        setUserProfileNewPassword(event.target.value);
    }

    const onChangeSubLoginConfirmPassword = (event) => {
        setUserProfileConfirmPasswordError('');
        setUserProfileConfirmPassword(event.target.value);
    }
    const BindIndivualId = (loginUserID) => {
        let Auth0token = localStorage.getItem('Auth0token')
        if (loginUserID != null && loginUserID != "" && loginUserID != undefined) {
            fetch(Config.apiUrl + "UserCompany/ById?id=" + loginUserID, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: 'Bearer ' + Auth0token,

                },
            }).then((resp1) => {
                resp1.json().then((result) => {
                    if (result != null) {
                        setCurrentUserLoginName(result?.name);
                        setCurrentUserLoginEmail(result?.email);
                        setCurrentUserLoginPassword(result?.password);
                        localStorage.setItem('loginName', result.name);
                    }

                });
            });
        }
    }

    const UpdateUserProfilePassword = (e) => {
        setUserProfileConfirmPasswordError("");
        setUserProfileNewPasswordError("");
        e.preventDefault();
       
        var isValid = true;

        // if (UserProfileOldPassword === "" || UserProfileOldPassword === null || UserProfileOldPassword === undefined) {
        //     setUserProfileOldPasswordError("Old password is required.");
        //     isValid = false;
        //     return;
        // } 
        // else {
        //     if (UserProfileOldPassword != CurrentUserLoginPassword) {
        //         isValid = false;
        //         setUserProfileOldPasswordError("Sorry! Old password do not match. Please re-enter.");
        //         return;
        //     }
        // }

        if (UserProfileNewPassword === "" && UserProfileNewPassword === null && UserProfileNewPassword === undefined) {
            isValid = false;
            setUserProfileConfirmPasswordError("Confirm password is required.");
            return;
        }
        else {
            if (UserProfileConfirmPassword != "" && UserProfileConfirmPassword != null && UserProfileConfirmPassword != undefined) {
                if (UserProfileNewPassword != UserProfileConfirmPassword) {
                    isValid = false;
                    setUserProfileConfirmPasswordError("Sorry! New and Confirm Password are not matched.");
                    return;
                }
            }
            else {
                setUserProfileNewPasswordError("Confirm is required.");
            }
        }

        // if (UserProfileNewPassword != "" && UserProfileNewPassword != null && UserProfileNewPassword != undefined) {

        //     if (UserProfileConfirmPassword != "" && UserProfileConfirmPassword != null && UserProfileConfirmPassword != undefined) {
        //         if (UserProfileNewPassword != UserProfileConfirmPassword) {
        //             isValid = false;
        //             setUserProfileConfirmPasswordError("Sorry! New and Confirm Password are not matched.");
        //         }
        //     } else {

        //     }
        // } else {
        //     isValid = false;

        //     setUserProfileNewPasswordError("New password is required.");
        //     if (UserProfileConfirmPassword == "" || UserProfileConfirmPassword == null || UserProfileConfirmPassword == undefined) {
        //         isValid = false;
        //         setUserProfileNewPasswordError("Confirm is required.");
        //     }
        // }
        let Auth0token = localStorage.getItem('Auth0token');
        let auth0ID = localStorage.getItem('Auth0ID');
        if (isValid && auth0ID !== null && auth0ID !== "" && auth0ID !== undefined) {
            let Userid = localStorage.getItem("loginUserID");
            var data = {
                _id: Userid,
                Password: UserProfileNewPassword,
                Auth0ID:auth0ID
                // OldPassword: UserProfileOldPassword,
                // NewPassword: UserProfileNewPassword,
                // CPassword: UserProfileConfirmPassword
            }
            try {
                fetch(Config.apiUrl + "UserCompany/Updateuserpassword?id=" + Userid,
                {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        "userCompanyID": Userid,
                        Authorization: 'Bearer ' + Auth0token,
                    },
                    body: JSON.stringify(data)
                }).then((result) => {
                    result.json().then((resp) => {
                        if (resp !== null && resp !== "" && resp !== undefined && resp?._id !== null && resp?._id !== "" && resp?._id  !== undefined ) {
                            setshow(true);
                            setSubloginId(resp._id);
                            UserProfileclearform();
                            swal("Saved", "UserProfile Password are Updated.", "success");
                        }
                        else
                            swal("Sorry!", "your account has been social media so you can not update the password", "warning");
                    })
                }) 
            } catch (error) {
                console.log("error==>" , error)
                swal("Sorry!", "please contact administrator", "error");
            }
                            
           
        }
    }

    const UserProfileclearform = () => {
        setUserProfileNewPassword("");
        setUserProfileOldPassword("");
        setUserProfileConfirmPassword("");
        setUserID("");
    }
    // const UpdateUserProfilePassword = (event) => {
    //     let Auth0token = localStorage.getItem('Auth0token')
    //     let connectionName = localStorage.getItem('loginRoleName')
    //     let isValid = true

    //     var axios = require("axios").default;

    //     var options = {
    //         method: 'POST',
    //         url: 'https://YOUR_DOMAIN/dbconnections/change_password',
    //         headers: {
    //             'content-type': 'application/json',
    //         },
    //         data: {
    //             client_id: 'CQK7qF4iOl90HWaIVX3iTljiGMFbP02P',
    //             email: 'dabhi@123gmail.com',
    //             connection: 'Username-Password-Authentication'
    //         }
    //     };

    //     axios.request(options).then(function (response) {
    //         console.log(response.data);
    //     }).catch(function (error) {
    //         console.error("error=>",error);
    //     });
    // }
    return (

        <div>
            <div>
                <ol className="breadcrumb float-xl-right">
                    <li className="breadcrumb-item"><a href="./home">Home</a></li>
                    <li className="breadcrumb-item active">Password management</li>
                </ol>
                <h1 className="page-header">Password management</h1>
                <div className='mt-4'>
                    {/* <PanelHeader>
                    <h4 className='mb-0 text-light'>Password management</h4>
                    </PanelHeader>
                    <PanelBody> */}
                    <div className="row password-css">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-2 font-css">Name</div>
                        <div className="d-none d-md-block">:</div>
                        <div className="col-sm-2 font-css-1"> {CurrentUserLoginName}</div>
                    </div>
                    <div className="row  password-css">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-2 font-css">Email </div>
                        <div className="d-none d-md-block">:</div>
                        <div className="col-sm-2 font-css-1">{CurrentUserLoginEmail}</div>
                    </div>
                    {/* <div className="row  password-css">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-2 font-css">Old Password</div>
                        <div className="d-none d-md-block">:</div>
                        <div className="col-sm-3 font-css-1">
                            <input type="text"
                                className="form-control input-design-1 width250"
                                placeholder="Please Enter Password"
                                value={UserProfileOldPassword}
                                onChange={onChangeSubLoginOldPassword}
                            />{(UserProfileOldPasswordError != "" && UserProfileOldPasswordError != null) ?
                                <div className="mt-0 text-red ">
                                    {UserProfileOldPasswordError}
                                </div>
                                : ""}</div>
                    </div> */}
                    <div className="row  password-css">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-2 font-css">New Password</div>
                        <div className="d-none d-md-block">:</div>
                        <div className="col-sm-3 font-css-1">
                            <input type="text"
                                className="form-control input-design-1 width250"
                                placeholder="Please Enter Password"
                                value={UserProfileNewPassword}
                                onChange={onChangeSubLoginNewPassword}
                            />{(UserProfileNewPasswordError != "" && UserProfileNewPasswordError != null) ?
                                <div className="mt-0 text-red ">
                                    {UserProfileNewPasswordError}
                                </div>
                                : ""}</div>
                    </div>
                    <div className="row  password-css">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-2 font-css">Confirm Password</div>
                        <div className="d-none d-md-block">:</div>
                        <div className="col-sm-3 font-css-1">
                            <input type="text"
                                className="form-control input-design-1 width250"
                                placeholder="Please Enter Confirm Password"
                                value={UserProfileConfirmPassword}
                                onChange={onChangeSubLoginConfirmPassword}
                            />{(UserProfileConfirmPasswordError != "" && UserProfileConfirmPasswordError != null) ?
                                <div className="mt-0 text-red ">
                                    {UserProfileConfirmPasswordError}
                                </div>
                                : ""}</div>

                    </div>

                    <div className="row">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-2">
                            {/* {
                                Auth0ID.split("|")[0] === "google-oauth2" ?
                                // <button type="button" className="btn btn-primary" onClick={(e) => { swal("your account has been google login") }}>Update Password</button>
                                
                                : <button type="button" className="btn btn-primary" onClick={(e) => { UpdateUserProfilePassword(e) }}>Update Password</button>
                            } */}
                           <button type="button" className="btn btn-primary" onClick={(e) => { UpdateUserProfilePassword(e) }}>Update Password</button>

                        </div>

                    </div>
                    {/* </PanelBody>*/}
                </div>
            </div>


        </div>
    )

}

export default Passwordmanagement;